(function () {
  var STORAGE_KEY = 'dp_recently_viewed';
  var MAX_ITEMS = window.matchMedia('(max-width: 749px)').matches ? 4 : 8;;

  var currentEl = document.querySelector('[data-dp-current-product]');
  if (currentEl) {
    try {
      var current = JSON.parse(currentEl.textContent);
      var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      stored = stored.filter(function (p) { return p.handle !== current.handle; });
      stored.unshift(current);
      stored = stored.slice(0, MAX_ITEMS);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    } catch (e) {}
  }

  var section = document.querySelector('[data-dp-recently-viewed]');
  var list = document.querySelector('[data-dp-recently-viewed-list]');
  if (!section || !list) return;

  try {
    var items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    if (currentEl) {
      var current2 = JSON.parse(currentEl.textContent);
      items = items.filter(function (p) { return p.handle !== current2.handle; });
    }
    if (items.length === 0) return;

    list.innerHTML = items.map(function (p) {
      return '<div class="dp-grid__item"><a href="' + p.url + '" class="dp-card"><div class="dp-card__image-wrap">' +
        (p.image ? '<img src="' + p.image + '" class="dp-card__image" alt="" loading="lazy">' : '') +
        '</div><div class="dp-card__info"><p class="dp-card__title">' + p.title +
        '</p><p class="dp-card__price"><span class="dp-card__price-current">' + p.price + '</span></p></div></a></div>';
    }).join('');
    section.hidden = false;
  } catch (e) {}
})();